import { httpUpload } from './http.service';

export const uploadImageApi = async (file) =>
  await httpUpload.post(`/base/upload/file`, file, {
    errorHandler: true,
  });
